import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=36dab473&"
import script from "./Indicadores.vue?vue&type=script&lang=js&"
export * from "./Indicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports